import { StepsTheme as StepsThemeTheme } from "@acin.reactjs/acin-ui/steps";
import { applyIconColor } from "@acin.reactjs/acin-ui/theme";
import { DefaultTheme } from "styled-components";

const StepsTheme = (theme: DefaultTheme): StepsThemeTheme => ({
  steps: {
    step: {
      root: {
        borderColor: theme.palette.secondary[500],
      },
      current: {
        background: theme.palette.common.white,
        color: theme.palette.common.black,
        boxShadow: `${theme.palette.secondary[100]} 0px 0px 0px 4px`,
      },
      previous: {
        background: theme.palette.secondary[500],
        color: theme.palette.common.black,
        borderColor: theme.palette.secondary[500],
      },
      checkIcon: {
        ...applyIconColor(theme.palette.common.black),
      },
      complete: {
        background: theme.palette.secondary[500],
      },
    },
    line: { active: { background: theme.palette.secondary[500] } },
  },
  mobile: {
    labels: { label: { color: theme.palette.common.black } },
  },
});

export default StepsTheme;
